import { FC } from "react";
import Image from "next/image";
import GImage from "@/components/GImage";
import dayjs from "dayjs";
import Link from "next/link";
import { Course } from "@/fetch/academy";
import { ClickableCard } from "@/components/Card";
import Typography from "@/components/Typography";
import Avatar, { AvatarGroup } from "@/components/Avatar";
import Tooltip from "@/components/Tooltip";
import styles from "./MobileLanguageCourseCard.module.scss";

type Props = {
  course: Course;
};

const MobileLanguageCourseCard: FC<Props> = ({ course }) => {
  const bannerImage = `https://res.cloudinary.com/gwatco/image/upload/f_auto,q_auto,h_180,dpr_2.0/${course.cover}.png`;
  const duration = dayjs
    .duration(course.total_length_in_min, "minutes")
    .format("H[h] m[m]")
    .replace(/\b0+[a-z]+\s*/gi, "")
    .trim();

  const avatarImageUrl = course.enrolments.sample_enrolments
    .slice(0, 3)
    .map(
      (each) =>
        `https://res.cloudinary.com/gwatco/image/upload/ar_1.0,c_thumb,g_auto/${each.s3_profile_pic}`
    );

  return (
    <Link href={`/academy/${course.id}`} passHref>
      <div className={styles.container}>
        <div className={styles.content}>
          <Typography variant="body1" className={styles.title}>
            {course.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {duration}
          </Typography>
        </div>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={bannerImage}
          alt={course?.title}
          className={styles.bannerImage}
        />
      </div>
    </Link>
  );
};

export default MobileLanguageCourseCard;
